import axios from '../axios'
import { CONFIGCACHEROUTES } from 'src/router/Api'

export const getListConfigCache = async () => {
	return await axios.get(CONFIGCACHEROUTES.name)
}

export const updateConfigCache = async (key: string, value: number) => {
	return await axios.put(CONFIGCACHEROUTES.item(key), { value })
}

export const incrementConfigCache = async (key: string) => {
	return await axios.post(CONFIGCACHEROUTES.increment(key))
}
